<template>
    <SimpleTable
        :flat="true"
        title="Asientos liberados"
        subtitle="Asientos disponibles para recuperación"
        :columns="columns"
        :data="items"
        :loading="loading"
        empty-text="Este abonado no ha liberado ningún asiento"
        :default-col-width="defaultColWidth"
    >
        <template #cell-fecha="{ value }">
            {{ formatDate(value) }}
        </template>

        <template #cell-estado="{ value }">
            <span :class="['tw:px-2 tw:py-1 tw:rounded tw:text-xs tw:font-medium', getStatusClass(value)]">
                {{ getStatusLabel(value) }}
            </span>
        </template>

        <template #cell-acciones="{ row }">
            <Button
                v-if="row.estado === 0 && showRecuperar"
                @click="$emit('liberar', row.id)"
                variant="success"
                class="tw:text-xs tw:sm:text-sm"
            >
                Recuperar
            </Button>
            <Button
                v-else-if="showRecuperar"
                disabled
                variant="ghost"
                class="tw:text-xs tw:sm:text-sm"
            >
                Vendido
            </Button>
        </template>
    </SimpleTable>
</template>

<script setup>
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        items: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        showRecuperar: {
            type: Boolean,
            default: true
        },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    })

    const emit = defineEmits(['liberar'])

    const columns = [
        { key: 'evento_name', label: 'Evento' },
        { key: 'zona_name', label: 'Zona' },
        { key: 'fila', label: 'Fila' },
        { key: 'asiento', label: 'Asiento' },
        { key: 'fecha', label: 'Fecha' },
        { key: 'estado', label: 'Estado' },
        { key: 'acciones', label: '' }
    ]

    function getStatusClass(estado) {
        return estado === 0 ? 'tw:bg-yellow-100 tw:text-yellow-800' : 'tw:bg-gray-100 tw:text-gray-800'
    }

    function getStatusLabel(estado) {
        return estado === 0 ? 'Disponible' : 'Vendido'
    }

    function formatDate(dateString) {
        if (!dateString) return ''
        const date = new Date(dateString)
        return date.toLocaleDateString('es-AR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        })
    }
</script>
